<div class="d-flex flex-column h-100 main-cont item-container">
  <div class="c-header d-flex justify-content-between item-header">
    <div class="b-btn medium-sans d-flex align-items-center back-btn ">
      <span class="heading-2">View Preview</span>
    </div>
    <div mat-dialog-close class="se-icon">
      <img class="img-div2 cursor-pointer" class="img-fluid" src="assets/images/icons/close_icon.svg" alt="">
    </div>
  </div>
  <div class="c-container d-flex flex-grow-1 item-content" *ngIf="subSectionData">
    <div class="row d-flex flex-grow-1">
      <div class="col-12 col-lg-3 order-2 order-lg-1 d-flex flex-column mt-3 mt-lg-0">
        <div class="c-sidebar flex-grow-1 course">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
            *ngFor="let item of sectionDataArr;let i=index" [expanded]="item.s_i==subSectionData.s_i">
            <mat-expansion-panel-header class="ti-box medium-sans">
              <mat-panel-title class="se-b d-flex medium-sans">
                <div class="num-box me-2 ">{{i+1}}</div>
                <div class="p-tit">{{item.s_tit}}</div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="template-content-box pb-2">
              <div class="item-box d-flex cursor-pointer" *ngFor="let value of item.sub_s;let j=index"
                (click)="onSubSection(item.s_i,value)" [ngClass]="{'sel-sec':((value.s_si==subSectionData.s_si) && dialogData?.parentMenu != 'AddCourse')||
                ((j==subSectionId && (dialogData?.parentMenu == 'AddCourse')))
               }">
                <div class="d-flex justify-content-between ps-4  w-100">
                  <div class="d-flex align-items-center ">
                    <div class="object-icon me-2">
                      <img *ngIf="value.type=='text'" src="assets/images/object_icons_new/text.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='audio'" src="assets/images/object_icons/audio.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='video'" src="assets/images/object_icons/video.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='youtube'" src="assets/images/object_icons_new/youtube.svg"
                        class="img-fluid" alt="">
                      <img *ngIf="value.type=='pdf'" src="assets/images/object_icons_new/pdf.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='file'" src="assets/images/object_icons_new/file.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='image'" src="assets/images/object_icons/image.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='link'" src="assets/images/object_icons_new/link.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='exam'" src="assets/images/object_icons/quiz.svg" class="img-fluid"
                        alt="">
                      <img *ngIf="value.type=='iframe'" src="assets/images/object_icons/iframe.svg" class="img-fluid"
                        alt="">
                        <img *ngIf="value.type=='document'" src="assets/images/object_icons_new/file.svg" class="img-fluid" alt="">
                    </div>
                    <div *ngIf="value.sub_tit" class="subs-txt">{{value.sub_tit}}</div>
                    <div *ngIf="!value.sub_tit" class="subs-txt">Sub section {{j+1}}</div>
                  </div>
                  <div *ngIf="value.is_completed==1"> <img src="assets/images/icons/tick_mark.svg" class="img-fluid"
                      alt="">
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      </div>
      <div class="col-12  d-flex mt-3 mt-lg-0"
        [ngClass]="{'col-lg-9 order-2' : (previewType.themePreview==false),'col-lg-6 order-3 order-lg-2' : previewType.themePreview==true}">
        <div class="flex-grow-1 c-course d-box w-100" [ngClass]="(selectedTheme.tem_img!=''&&(coursePreviewType=='desktop'))?'white-bg':''">
          <div [ngTemplateOutlet]="changePreview" class="" *ngIf="coursePreviewType=='mobile'"></div>
          <div class=" flex-grow-1 d-flex flex-column bg-img"
            [style.background-image]="'url('+ imageURL+selectedTheme.tem_img +')' " [ngClass]="{'w-100 course-content':coursePreviewType=='desktop',                                               
            'white-bg': (selectedTheme.tem_img==''&&(coursePreviewType=='desktop')),'bg-transperant':(coursePreviewType=='mobile')}">
            <div [ngTemplateOutlet]="changePreview" *ngIf="coursePreviewType=='desktop'"></div>
            <div class="flex-grow-1 d-flex mob-box flex-column w-100" *ngIf="subSectionData">
              <div class="" [ngTemplateOutlet]="courseObject"  *ngIf="coursePreviewType=='desktop'"></div>
              <div class="mobile-container  m-auto" *ngIf="coursePreviewType=='mobile'"
               [style.background-image]="'url('+selectedTheme+')'" [ngClass]="{'theme-cont': selectedTheme!=''}">
                    <div class="mob-header pt-3 pb-3">
                      <span class="sentence-wrapper mx-2">{{subSectionData.sub_tit}}</span>
                      <div class="mobile-curve"><img src="assets/images/apps/mobile_header_curve.png" alt=""></div>
                    </div>
                    <div class="mobile-content d-flex flex-column" [style.background-image]="'url('+ imageURL+selectedTheme.tem_img +')' " >
                      <div class="m-con-box flex-grow-1">
                       <div class="" [ngTemplateOutlet]="courseObject"></div>
    
                      </div>
    
                    </div>
              </div>
            </div>              
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-3 order-1 order-lg-3 d-flex" *ngIf="previewType.themePreview" [ngClass]="{}">
        <div class="c-theme flex-grow-1 d-flex flex-column  justify-content-between">
          <div>
            <p class="text-black mb-0">Course Theme</p>
            <p class="small-text">Edit the theme for all lessons in this course.</p>
            <div class="d-flex flex-wrap">
              <div class="theme-item cursor-pointer mt-2" *ngFor="let item of themeArr" (click)="onSelectTheme(item)"
                [style.background-image]="'url('+imageURL+item.tem_img+')'"
                [ngClass]="item.id==selectedTheme.id ? 'sel-theme':''">
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap btn-div">
            <button class="btn btn-outline-primary me-2 mt-2" (click)="onCancel()">Cancel</button>
            <button mat-raised-button color="primary" class="mr-3 no-sh-btn mt-2" (click)="onApply()">Apply</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sticky-cont d-block d-lg-none">
    <div class="" [ngTemplateOutlet]="buttonTemplate"></div>
  </div>
</div>
<ng-template #changePreview>
  <div class="d-flex align-items-center justify-content-end w-100 mb-3 device-preview">
    <div class="t-b cursor-pointer" (click)="onChangePreviewType('desktop')"
      [ngClass]="coursePreviewType=='desktop' ? 't-active ':'' ">
      <i class="material-icons me-2">desktop_mac</i> <span>Desktop</span>
    </div>
    <div class="t-b ms-3 cursor-pointer" (click)="onChangePreviewType('mobile')"
      [ngClass]="coursePreviewType=='mobile' ? 't-active ':''">
      <i class="material-icons me-2">phone_android</i><span>Mobile</span>
    </div>
  </div>
</ng-template>
<ng-template #courseObject>
  <div class="flex-grow-1 my-3 preview-course"
    [ngClass]="((coursePreviewType=='mobile')&&(subSectionData.type!='text')) ? 'd-box':''">
    <div class="ql-snow" *ngIf="subSectionData.type=='text'">
      <div class="ql-editor small-text " [innerHtml]="subSectionData.subs_cont|safe:'html'"></div>
    </div>
    <div *ngIf="subSectionData.type=='image'" class="d-box" class="h-100 d-box">
      <div>
        <img [src]="subSectionData.subs_cont" class="img-fluid">
      </div>
    </div>
    <div *ngIf="subSectionData.type=='audio'" class="d-box audio-box h-100 w-100">
      <div class="audio-img">
        <img src="assets/images/object_icons/audio_xl.svg" class="img-fluid" alt="">
      </div>
      <div class="heading-1 mt-3 mt-xl-5">{{subSectionData.sub_t}}</div>
      <audio controls style="width:100%;max-width:700px" class="my-2" #audio>
        <source [src]="subSectionData.subs_cont" type="audio/mpeg">
      </audio>
      <div class="play-btn d-box cursor-pointer" (click)="onPlayPauseAudio()">
        <i class="material-icons" *ngIf="isPlayButton">play_arrow</i>
        <i class="material-icons" *ngIf="!isPlayButton">pause</i>
      </div>
    </div>
    <div *ngIf="subSectionData.type=='video'" [ngClass]="coursePreviewType=='desktop' ? 'c-item':''">
      <video width="100%" height="100%" class="m-auto d-flex " controls #video>
        <source [src]="subSectionData.subs_cont" type="video/mp4">
      </video>
    </div>
    <div *ngIf="subSectionData.type=='iframe'" [ngClass]="coursePreviewType=='desktop' ? 'c-item':''">
      <iframe [src]="subSectionData.subs_cont  | safe: 'resourceUrl'" height="100%" width="100%"></iframe>
    </div>
    <div *ngIf="subSectionData.type=='youtube'" [ngClass]="coursePreviewType=='desktop' ? 'c-item':''">
      <iframe [src]="extractVideoId(subSectionData.subs_cont)" height="100%" width="100%"></iframe>
    </div>
    <div *ngIf="subSectionData.type=='link'" class="c-item">
      <iframe [src]="subSectionData.subs_cont | safe: 'resourceUrl'" class="iframe-link" height="100%" width="100%"
        id="iframe" style="background-color:#FFF"></iframe>
    </div>
    <div *ngIf="subSectionData.type=='file'" class="h-100 d-box">
      <div>
        <img src="assets/images/object_icons/file_download.svg" class="img-fluid">
      </div>
      <button mat-raised-button class="mt-4 btn no-sh-btn  success-btn" type="button" (click)="onDownload()">
        <img src="assets/images/icons/download.png" class="img-fluid me-2">Download</button>
    </div>
    <div *ngIf="subSectionData.type=='pdf'" class="w-100 h-100">

        <pdf-viewer [src]="subSectionData.subs_cont" *ngIf="coursePreviewType=='mobile'"
        [render-text]="true"
        [original-size]="false"
        style="width: 100%; height: 100%" ></pdf-viewer>
      <pdf-viewer [src]="subSectionData.subs_cont" style="width: 100%; height: 95%" [render-text]="true" *ngIf="coursePreviewType=='desktop'"
        [original-size]="false"></pdf-viewer>
    </div>
    <div *ngIf="subSectionData.type=='exam'">
      <app-individual-exam [childData]="examData" (childEvent)="examComponentEvent($event)"></app-individual-exam>
    </div>
  </div>

  <div class="d-none d-lg-block">
    <div [ngTemplateOutlet]="buttonTemplate"></div>
  </div>


</ng-template>
<ng-template #buttonTemplate>
  <div class="d-flex align-items-center justify-content-center btn-container" *ngIf="subSectionData && subSectionData.type!='exam'">
    <button class="btn btn-outline-primary me-2" *ngIf="isBackAvailable" (click)="onBack()">Back</button>
    <button mat-raised-button color="primary" class="mr-3 no-sh-btn" (click)="onNext()">
      {{isCourseCompleted ? 'Completed':"Next"}}</button>
  </div>
</ng-template>
<app-loading-spinner></app-loading-spinner>